import { makeAutoObservable } from "mobx";
import { ENDPOINTS } from "services";

import { downloadFileBlob } from "utils";
import { TTemplateCode, TTemplate } from "interfaces/templates";
import { getAllTemplates, getTemplateType, uploadTemplateFile } from "services/templateService";
import { fetchStatus, withRequestTracking } from "utils/storesUtils";
import { isArray } from "lodash";

export class Templates {
  allTemplates: TTemplate[] = [];
  templateCodes: TTemplateCode | null = null;

  templatesStatuses = { loading: false, fetchStatus: fetchStatus.idle, fetchError: undefined };
  templateCodesStatuses = { loading: false, fetchStatus: fetchStatus.idle, fetchError: undefined };
  downloadFileStatuses = { loading: false, fetchStatus: fetchStatus.idle, fetchError: undefined };
  downloadDefaultFileStatuses = { loading: false, fetchStatus: fetchStatus.idle, fetchError: undefined };
  uploadFileStatuses = { loading: false, fetchStatus: fetchStatus.idle, fetchError: undefined };

  constructor() {
    makeAutoObservable(this);
  }

  async getTemplates() {
    return withRequestTracking(this.templatesStatuses, async () => {
      const res = await getAllTemplates();
      this.allTemplates = isArray(res) ? res.sort((a) => (a.format === "DOC" ? -1 : 1)) : [];
    });
  }

  async getTemplateCodes(type: string) {
    return withRequestTracking(this.templateCodesStatuses, async () => {
      const res = await getTemplateType(type);
      this.templateCodes = res;
    });
  }

  async downloadFile(type: string) {
    return withRequestTracking(this.downloadFileStatuses, async () => {
      await downloadFileBlob(ENDPOINTS.downloadTemplateFile(type), true);
    });
  }

  async downloadDefaultFile(type: string) {
    return withRequestTracking(this.downloadDefaultFileStatuses, async () => {
      return await downloadFileBlob(ENDPOINTS.downloadDefaultTemplateFile(type), true);
    });
  }

  async uploadFile(file: File, type: string) {
    const formData = new FormData();
    formData.append("file", file);

    return withRequestTracking(this.uploadFileStatuses, async () => {
      await uploadTemplateFile({ formData, type });
    });
  }
}
